import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import countries from 'constants/countries';
import { BE_COUNTRY, NL_COUNTRY } from './VatAddress';
import serviceTypeCodes from 'constants/serviceTypeCodes';

const CountriesVAT = ({ countryCode, serviceTypeCode }) => {
  if (countryCode === BE_COUNTRY && serviceTypeCode === serviceTypeCodes.SNCB)
    return (
      <>
        SNCB <FormattedMessage id="receipt.vat" />
      </>
    );

  if (countryCode === NL_COUNTRY && serviceTypeCode === serviceTypeCodes.NS)
    return (
      <>
        NS <FormattedMessage id="receipt.vat" />
      </>
    );

  const count = countries.find(({ code }) => code === countryCode)?.name ?? countryCode;
  return (
    <>
      {count} <FormattedMessage id="receipt.vat" />
    </>
  );
};

CountriesVAT.propTypes = {
  countryCode: PropTypes.string,
  serviceTypeCode: PropTypes.string
};

export default CountriesVAT;
